module.exports = __webpack_public_path__ + "static/media/user-icon.cc1d25ad.svg";